import ProgramIndex from "@/views/layanan/program/ProgramIndex.vue";

const program = [
    {
        path: '/programs',
        name: 'program',
        component: ProgramIndex
    }
]

export default program